import React from 'react';

const NotFound = () => (
    <div>
        <h2>Nothing to be found here</h2>
    </div>
);

export default NotFound;
